import React, { useRef, useEffect, useState } from 'react';
import { cn } from '@/lib/utils';

interface ExpandableRowProps {
  isExpanded: boolean;
  children: React.ReactNode;
}

export const ExpandableRow: React.FC<ExpandableRowProps> = ({ isExpanded, children }) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState<number | undefined>(0);

  useEffect(() => {
    if (contentRef.current) {
      const scrollHeight = contentRef.current.scrollHeight;
      setHeight(isExpanded ? scrollHeight : 0);
    }
  }, [isExpanded, children]);

  return (
    <div
      className={cn(
        "overflow-hidden transition-all duration-300 ease-in-out",
        isExpanded ? "opacity-100" : "opacity-0"
      )}
      style={{ height: height ? `${height}px` : '0px' }}
    >
      <div ref={contentRef}>
        {children}
      </div>
    </div>
  );
};
